// Generated by genversion.
export const version = '2.54.0';
//# sourceMappingURL=version.js.map